import { useEffect } from 'react';
import Antigravity from './Antigravity';

export default function LandingPage() {
  useEffect(() => {
    document.body.style.margin = '0';
    document.body.style.padding = '0';
  }, []);

  return (
    <div style={{ width: '100%', height: '100vh', minHeight: 500 }}>
      <Antigravity
        count={1900} magnetRadius={6} ringRadius={7} waveSpeed={1.4} waveAmplitude={1}
        particleSize={1} lerpSpeed={0.05} color="#FFD600" autoAnimate
        particleVariance={1} rotationSpeed={1} depthFactor={1} pulseSpeed={4.8}
        particleShape="sphere" fieldStrength={10}
      />
    </div>
  );
}
